import offlineFairInstance from "./axios-instances/offlineFairInstance";

export function fetchUniversityDetails(data) {
	return offlineFairInstance.post("/fairs/universities/check_university", data);

	// return new Promise((resolve) => {
	// 	setTimeout(
	// 		() =>
	// 			resolve({
	// 				data: {
	// 					fair_id: "5032258000000674051",
	// 					university: {
	// 						$approval_state: "approved",
	// 						$approved: true,
	// 						$currency_symbol: "₹",
	// 						$editable: true,
	// 						$in_merge: false,
	// 						$orchestration: false,
	// 						$process_flow: false,
	// 						$state: "save",
	// 						Account_Name: "Institute of Technology Carlow (EduCo)",
	// 						City: "Ireland",
	// 						Data_Source2: "Alliance team",
	// 						Event_Date: "Wed, 12 Jan 2022 08:30:00 GMT",
	// 						University_Active: true,
	// 						WES_Required: false,
	// 						Website: "www.itcarlow.ie/international.htm",
	// 						id: 5032258000000432207,
	// 						module: "Accounts",
	// 					},
	// 					university_code: "32123",
	// 				},
	// 			}),
	// 		2000
	// 	);
	// });
}

export function setUniversityAsMustVisit(payload) {
	return offlineFairInstance.post("fairs/update/must_visit", payload);
}
